import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import { useContext } from 'react';
import { AuthContext } from '../context/Authcontext';

// Screen imports
import Users from '../pages/screens/users/Users';
import Pandits from '../pages/screens/pandits/Pandits';
import Departments from '../pages/screens/departments/Departments';
import Events from '../pages/screens/events/Events';
import Quizzes from '../pages/screens/quizzes/Quizzes';
import Prayers from '../pages/screens/prayers/Prayers';
import SpecialDays from '../pages/screens/specialdays/SpecialDays';
import Mandirs from '../pages/screens/mandirs/Mandirs';
import HindiLearning from '../pages/screens/hindilearning/HindiLearning';
import Kinderhuis from '../pages/screens/kinderhuis/Kinderhuis';
import EBibliotheek from '../pages/screens/ebibliotheek/EBibliotheek';
import DharmaLearning from '../pages/screens/dharmalearning/DharmaLearning';
import Schools from '../pages/screens/schools/Schools';
import Hoofdbestuur from '../pages/screens/hoofdbestuur/Hoofdbestuur';
import Blogs from '../pages/screens/blogs/Blogs';

function PrivateRoute({ children }) {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/" />;
}

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        {/* Admin Routes */}
        <Route
          path="/(Admins)/screens/users/adminUserList"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/pandits/adminPanditList"
          element={
            <PrivateRoute>
              <Pandits />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/departments/adminDepartmentList"
          element={
            <PrivateRoute>
              <Departments />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/events/adminEventList"
          element={
            <PrivateRoute>
              <Events />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/quizzes/adminQuizList"
          element={
            <PrivateRoute>
              <Quizzes />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/prayers/adminPrayerList"
          element={
            <PrivateRoute>
              <Prayers />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/specialdays/adminSpecialDaysList"
          element={
            <PrivateRoute>
              <SpecialDays />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/mandirs/adminMandirList"
          element={
            <PrivateRoute>
              <Mandirs />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/hindilearning/adminHindiLearningList"
          element={
            <PrivateRoute>
              <HindiLearning />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/kinderhuis/adminKinderhuisList"
          element={
            <PrivateRoute>
              <Kinderhuis />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/ebibliotheek/adminEBibliotheekList"
          element={
            <PrivateRoute>
              <EBibliotheek />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/dharmalearning/adminDharmaLeerList"
          element={
            <PrivateRoute>
              <DharmaLearning />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/schools/adminSchoolList"
          element={
            <PrivateRoute>
              <Schools />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/hoofdbestuur/adminHoofdbestuurList"
          element={
            <PrivateRoute>
              <Hoofdbestuur />
            </PrivateRoute>
          }
        />
        <Route
          path="/(Admins)/screens/blogs/adminBlogList"
          element={
            <PrivateRoute>
              <Blogs />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}
